import { NonBreakingCharEnum, } from '../types/characters';
/**
 * Remove formatting and extra characters from an Australian Business Number (ABN)
 *
 * @export
 * @param {string} abn
 * @return {*}  {string}
 */
export function stripAbn(abn) {
    return abn
        .replace(/\\u([0-9a-f]){4}/gi, '') // Remove any unicode escape sequences
        .replace(/[^0-9]/g, ''); // Remove any non-digit characters
}
/**
 * Format an Australian Business Number (ABN) for display.
 *
 *
 * @param {string} abn Australian Business Number (ABN)
 * @param {NonBreakingCharEnum} [separator=NonBreakingCharEnum.space] Separator to insert between digits. Either [empty] or [non-breaking space] or [non-breaking hyphen]
 * @return {*} A formatted string containing the input ABN
 */
export function formatAbn(abn, separator = NonBreakingCharEnum.space) {
    if (abn === 'NOT PROVIDED') {
        return abn;
    }
    // Remove any non-digit characters in case the input is not clean
    const str = abn.replace(/[^0-9]/g, '');
    // Check if the input is exactly 11 digits, if not, handle as needed
    if (str.length !== 11) {
        console.error('Invalid ABN: ABN must be exactly 11 digits');
        return 'Invalid ABN';
    }
    // Insert spaces to format as ABN
    return str.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, `$1${separator}$2${separator}$3${separator}$4`);
}
/**
 * Return true if the input string matches the format of a valid Australian Business Number (ABN)
 *
 * @export
 * @param {string} startAbnStr The ABN to check
 * @return {*}  {boolean} true if valid, otherwise false
 */
export function validateAbn(startAbnStr) {
    const ABN_POSITION_WEIGHTINGS = [
        10,
        1,
        3,
        5,
        7,
        9,
        11,
        13,
        15,
        17,
        19,
    ];
    const splitAbnStr = startAbnStr.substring(0, 11).split('');
    if (splitAbnStr.length === 11) {
        splitAbnStr[0] = `${Number.parseInt(splitAbnStr[0]) - 1}`;
        let sum = 0;
        for (let i = 0; (i < splitAbnStr.length) && (i < ABN_POSITION_WEIGHTINGS.length) && (i < 11); i++) {
            const weightedDigit = Number.parseInt(splitAbnStr[i]) * ABN_POSITION_WEIGHTINGS[i];
            sum = sum + weightedDigit;
        }
        return sum % 89 === 0;
    }
    else {
        return false;
    }
}
/**
 * Lookup details of a valid ABN
 *
 * @export
 * @param {string} abn The ABN to lookup
 * @return {*}  {JSONValue} object containing lookup result details
 */
export async function lookupAbn(abn) {
    const isValid = validateAbn(abn);
    if (!isValid) {
        return false;
    }
    const guid = '4323553b-7eca-4ef2-974d-97c38996e1a9';
    const lookupParams = new URLSearchParams({
        callback: 'abnCb',
        abn,
        guid,
    });
    const lookupUrl = new URL(`https://abr.business.gov.au/json/AbnDetails.aspx?${lookupParams.toString()}`);
    const response = await fetch(lookupUrl);
    const responseText = await response.text();
    console.info(`AddUserModal.checkABN response:`, responseText);
    const jsonString = responseText.substring(responseText.indexOf('{'), responseText.indexOf(')'));
    const jsonData = JSON.parse(jsonString);
    if (jsonData.Message.length !== 0) {
        return false;
    }
    return jsonData.EntityName;
}
//# sourceMappingURL=abn.js.map